import Component from '../core/Component'

export default class Body extends Component {

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {

        let target = null
        const matches = event.target.matches || event.target.matchesSelector

        if (event.target.tagName.toLowerCase() === 'a') {
            target = event.target
        } else {
            target = event.target.closest('a')
        }

        if (target && target::matches('a[href^=http]')) {
            event.preventDefault()
            window.open(target.href)
        }
    }

}